import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../../App';
import { store } from '../../../store';

export const getTeams = () => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() + `team/team-trade-assingment-tree`
  );
};
export const getTeamsDetail = (team_id: string) => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() + `team/one-detail?team_id=` + team_id
  );
};
export const teamUpdate = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(GetBackendUrlForGlobalFunctions() + `team/update`, obj, {
    headers,
  });
};
export const teamDelete = (obj: Object) => {
  return axios.put(GetBackendUrlForGlobalFunctions() + `team/delete`, obj);
};
export const createTeam = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.post(GetBackendUrlForGlobalFunctions() + `team/add`, obj, {
    headers,
  });
};
